import { useMutation } from 'react-query';
import { consentDirector } from './index';

export const useMutationConsentDirector = () =>
  useMutation(async (payload) => {
    const result = await consentDirector(payload);
    const data = result?.data ?? [];
    return data;
  });
